import styled from '../../../styles/theme';
import { ModalLeadFormStyled } from '../ModalLeadFormStyled';
import { rem } from 'polished';

export const ModalLeadFormStyledOV = styled(ModalLeadFormStyled)`
    .btn-primary {
        width: 100%;
        text-decoration: none;
        
        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.black};
            color: ${({ theme }) => theme.colors.white};
        }
    }
    
    .radiocheckbox-container {
        input[type='radio'] {
            &:checked {
                background: ${({ theme }) => theme.colors.primary};
                border-color: ${({ theme }) => theme.colors.primary};
                
                &::before {
                    background-color: ${({ theme }) => theme.colors.black};
                    width: ${rem(10)};
                    height: ${rem(10)};
                    top: ${rem(4)};
                    left: ${rem(4)};
                }
            }
        }
        
        input[type='checkbox'] {
            &:checked {
                background: ${({ theme }) => theme.colors.primary};
                border-color: ${({ theme }) => theme.colors.primary};
                
                &::before {
                    content: "";
                    border: 2px solid;
                    border-left: 0;
                    border-top: 0;
                    height: ${rem(12)};
                    left: ${rem(6)};
                    position: absolute;
                    top: ${rem(2)};
                    -webkit-transform: rotate(45deg);
                    -ms-transform: rotate(45deg);
                    transform: rotate(45deg);
                    -webkit-transition: opacity 0.2s ease-in-out;
                    transition: opacity 0.2s ease-in-out;
                    width: ${rem(6)};
                    color: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
`;
